import { FeedbackData } from "src/classes/models/interview";

interface IScoreBadge {
  feedback: FeedbackData;
}

const ScoreBadge = ({ feedback }: IScoreBadge) => {
  return (
    <p
      className="rounded-lg border-[1px] font-poppins shrink-0 text-[18px] font-semibold p-[8px] min-w-[52px] text-center "
      style={feedback._score.style}
    >
      {feedback.score}
    </p>
  );
};

export default ScoreBadge;
